export default __webpack_public_path__ + "static/media/pagseguro.bff4321b.png";